import React, { useEffect, useState } from "react";
import { Box, Text, SimpleGrid, Circle } from "@chakra-ui/react";
import { formatTextWithLineBreaks } from "../../../utils/formatText";
import { fetchLessonStructure } from "../../../services/homeContentService";
import { Colors } from "../../../static/static";
import Loader from "../../../components/common/Loader";
import "./lessonstructure.css";

function LessonStructure() {
  const [structureList, setStructureList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchLessonStructure();
        setStructureList(response || []);
      } catch (error) {
        setError("Failed to load profiles");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [])

  if (loading) {
    return <Loader />
  }
  if (error) {
    return <Text color="red">{error}</Text>;
  }

  return (
    <Box
      className="lessonstructure-container"
      p={8}
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight={{base: "100vh"}}
      flexDirection="column"
      width="100%"
      bgColor={Colors.bgBlack}
      bgImage={{ base: "none", md: "url('https://leadguitar.s3.eu-north-1.amazonaws.com/images/lesson-structure.jpeg')" }} 
      bgSize="cover"
      bgPosition="center"
      bgRepeat="no-repeat"
      zIndex="-1"
    >
      <Box mb={8} id="LessonStructure">
        <Text
          as="h2"
          fontSize={{base: '1.4rem', md:"6vh"}}
          textAlign="center"
          lang="he"
          color={Colors.heading}
          fontWeight={600}
        >
          סילבוס
        </Text>
      </Box>

      <Box width={{ base: "100%", md: "80%" }}>
        <SimpleGrid
          columns={{ base: 1, md: 2, lg: 3 }}
          spacing={{ base: "3", md: "10" }}
        >
          {structureList.map((details) => (
            <Box
              key={details.id}
              borderWidth={1}
              borderRadius="lg"
              overflow="hidden"
              p={4}
              bg={Colors.bgText}
              boxShadow="md"
              textAlign="center"
              alignItems="center"
              transition="background-color 0.3s, transform 0.6s"
              _hover={{ bg: "gray.200"}}
            >
              <Circle
                size={{ base: "2.5vh", md: "4vh" }}
                bg="#145c5b"
                color="white"
                position="relative"
                right="45%"
              >
                <Text fontSize="2vh" fontWeight="bold">
                  {details.id}
                </Text>
              </Circle>
              <Text fontSize={{ base: "1.2rem", md: "3vh" }} fontWeight="bold">
                {details.title}
              </Text>
              <Text mt={2} fontSize={{base: "1rem", md: '2vh'}} dir="rtl">
                {formatTextWithLineBreaks(details.text)}
              </Text>
            </Box>
          ))}
        </SimpleGrid>
      </Box>
    </Box>
  );
}

export default LessonStructure;
